import React from 'react';
import { Button, Alert, Spinner } from 'reactstrap';
import GoogleLogin from 'react-google-login';
import FacebookLogin from 'react-facebook-login/dist/facebook-login-render-props';
import { useAuth } from 'hooks';

const CLIENT_ID = process.env.REACT_APP_CLIENT_ID;
const FB_CLIENT_ID = process.env.REACT_APP_FB_CLIENT_ID;

const LoginWithSocialNetwork = () => {
  const {
    login: { handleSocialLogin },
    loading,
    error,
    clearMesages,
  } = useAuth();

  return (
    <div>
      <div className="mt-4 text-center">
        <h5 className="font-size-14 mb-3">Or, you can...</h5>

        {(error || loading) && (
          <Alert
            color={error ? 'danger' : loading && 'info'}
            toggle={error ? clearMesages : null}
          >
            {loading && (
              <Spinner size="sm" className="me-3">
                Loading...
              </Spinner>
            )}
            {error ? error : loading && 'Loading'}
          </Alert>
        )}

        <div className="d-flex flex-row gap-2 social-buttons">
          <GoogleLogin
            clientId={CLIENT_ID}
            render={renderProps => (
              <Button
                block
                className="_google"
                onClick={renderProps.onClick}
                disabled={renderProps.disabled}
              >
                <i className="mdi mdi-google me-3"></i> Login with Google
              </Button>
            )}
            buttonText="Login"
            onSuccess={response => handleSocialLogin(response, 'Google')}
            onFailure={response => handleSocialLogin(response, 'Google')}
            cookiePolicy={'single_host_origin'}
          />

          <FacebookLogin
            appId={FB_CLIENT_ID}
            autoLoad={false}
            fields="email,name"
            scope="email"
            returnScopes={true}
            callback={response => handleSocialLogin(response, 'Facebook')}
            render={renderProps => (
              <Button block className="_facebook" onClick={renderProps.onClick}>
                <i className="fab fa-facebook-f me-3"></i> Login with Facebook
              </Button>
            )}
          />
        </div>
      </div>
    </div>
  );
};

export default LoginWithSocialNetwork;
